/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import CTLogo from './ct_logo.colored.svg'
import Close from './close.svg'

class Header extends PureComponent {
  _redirectToHome = () => {
    window.location.href = this.props.menuLink
  }

  isFlyin = () => {
    return window.location.hostname.includes('flyin')
  }

  handleBackClick = () => {
    if (window.history && window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }

  isMobileDevice = () => {
    return window.innerWidth <= 768
  }

  renderFlyinHeader = () => {
    return (
      <div
        className="Header clearfix"
        style={{ height: '56px', position: 'relative' }}
      >
        {this.isMobileDevice() && (
          <div
            className="back-button-container"
            style={{
              padding: '10px 16px',
              cursor: 'pointer',
              position: 'absolute',
              left: '0',
              display: 'flex',
              alignItems: 'center',
              zIndex: 10
            }}
            onClick={this.handleBackClick}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#4A4A4A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
        <div className="" style={{ paddingTop: '10px' }}>
          <a href="/">
            <img
              src="https://ui.cltp.co/flyinstatic/common/themes/v1/images/flyinLogo.png"
              style={{ height: '36px' }}
              alt="Flyin Logo"
            />
          </a>
        </div>
      </div>
    )
  }

  render() {
    if (this.isFlyin()) {
      return this.renderFlyinHeader()
    }

    const { props } = this
    return (
      <div className="Header clearfix">
        <If condition={props.menu}>
          <div className="Header__menu">
            <Choose>
              <When condition={props.menu === 'active'}>
                <span className="Header__menuClose">
                  <Close className="Header__closeIcon" />
                </span>
              </When>
              <Otherwise>
                <span
                  className="Header__menuText"
                  onClick={this._redirectToHome}
                >
                  {props.menuTitle}
                </span>
              </Otherwise>
            </Choose>
          </div>
        </If>
        <div onClick={this._redirectToHome}>
          <CTLogo className="Header__logo" />
        </div>
      </div>
    )
  }
}

Header.displayName = 'Header'

Header.propTypes = {
  menu: PropTypes.bool,
  menuTitle: PropTypes.string,
  menuLink: PropTypes.string
}

Header.defaultProps = {
  menu: false,
  menuTitle: 'Menu',
  menuLink: '/'
}

export default Header
